// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDDchC4Pm27TC5BM2ul5QT-Kdux9QRvlLM",
  authDomain: "megashop-46712.firebaseapp.com",
  projectId: "megashop-46712",
  storageBucket: "megashop-46712.appspot.com",
  messagingSenderId: "112735432563",
  appId: "1:112735432563:web:e1c799c20c39a1d46a5f06",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export default app;
